<template>
  <div class="elite-tabs-wrapper-content">
    <log-list-table :filterSubject="taxGroup" />
  </div>
</template>
<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";

export default {
  name: "tax-group-view-logs",

  components: { LogListTable },

  props: ["taxGroup"],

  data() {
    return {};
  },
};
</script>
